/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type WorkflowActionTypeEnum = 'UNDEFINED' | 'DISPLAY_MESSAGE' | 'BLOCK_SALE' | 'STOP_EXECUTION' | 'SET_ENTRANCE' | 'ADD_DISCOUNT';

export const WorkflowActionTypeEnum = {
    UNDEFINED: 'UNDEFINED' as WorkflowActionTypeEnum,
    DISPLAY_MESSAGE: 'DISPLAY_MESSAGE' as WorkflowActionTypeEnum,
    BLOCK_SALE: 'BLOCK_SALE' as WorkflowActionTypeEnum,
    STOP_EXECUTION: 'STOP_EXECUTION' as WorkflowActionTypeEnum,
    SET_ENTRANCE: 'SET_ENTRANCE' as WorkflowActionTypeEnum,
    ADD_DISCOUNT: 'ADD_DISCOUNT' as WorkflowActionTypeEnum
};

